import React from 'react';
import PropTypes from 'prop-types';

import { ResponsiveCheck } from 'core/providers/Responsive';

import RatingStars from 'core/components/RatingStars';
import NoReviews from 'core/components/NoReviews/NoReviews';
import LoginModalHoc from 'core/hoc/LoginModalHoc';
import { FavoriteButton, Share } from 'listing/components';

import {
	Wrapper,
	Name,
	Intro,
	Row,
	ShareAndLike,
	Store,
	StoreLink,
	AdminLink,
	FlairTagContainer,
	MarketingBadge,
	NumSales,
	RatesAndSales
} from './titleStyles';
import { FlairTag } from 'core/styles';

const Title = ({
	slug,
	name,
	intro,
	stars,
	reviews,
	noMeta,
	listingId,
	customerId,
	noLikes,
	onWishlistSuccess,
	triggerLogin,
	className,
	storeName,
	hasMoreProducts,
	isAdmin,
	flairTags,
	marketingBadges,
	numSales
}) => (
	<ResponsiveCheck>
		{({ isDesktop, isMobile }) => (
			<Wrapper className={className}>
				{ marketingBadges?.length > 0 && (
					<MarketingBadge>
						{marketingBadges[0].label.toUpperCase()}
					</MarketingBadge>
				)}
				<Name>{name}</Name>
				{storeName && hasMoreProducts
					? <StoreLink to="more-products" smooth="easeInOutQuad" offset={-55}>by {storeName}</StoreLink>
					: <Store href={`/store/${slug}/`}>by {storeName}</Store>
				}
				{!noMeta && (
					<Row>
						<RatesAndSales>
							{!!numSales && (
								<NumSales>
									{numSales} {numSales == 1 ? "sale" : "sales"}
								</NumSales>
							)}
							{reviews > 0 ? (
								<RatingStars
									slug={slug}
									stars={stars}
									reviews={reviews}
									short
									anchorTo={"reviews"}
								/>
							) : (<NoReviews />)}
						</RatesAndSales>
						{isMobile &&
						<ShareAndLike>
							<Share url={`https://www.cratejoy.com/subscription-box/${slug}/`} />
							{!noLikes &&
							<FavoriteButton
								listingId={listingId}
								customerId={customerId}
								triggerLogin={triggerLogin}
							/>
							}
							{ isAdmin && <AdminLink href={`/subscription-box/${slug}/image_gallery/`} target={`blank`} title={`This icon only appears to CJ Admins.`}>🖼️</AdminLink> }
						</ShareAndLike>
						}
						{ isDesktop && isAdmin && <AdminLink href={`/subscription-box/${slug}/image_gallery/`} target={`blank`} title={`This icon only appears to CJ Admins.`}>🖼️</AdminLink> }
					</Row>
				)}
				<Intro dangerouslySetInnerHTML={{ __html: intro }} />

				{flairTags?.length > 0 && (
					<FlairTagContainer>
						{(flairTags||[]).map((flair) => (
							<FlairTag className={flair.tag} key={flair.tag}>
								{flair.label}
							</FlairTag>
						))}
					</FlairTagContainer>
				)}
			</Wrapper>
		)}
	</ResponsiveCheck>
);


export const titleProps = {
	name: PropTypes.string.isRequired,
	intro: PropTypes.string.isRequired,
	slug: PropTypes.string.isRequired,
	stars: PropTypes.number,
	reviews: PropTypes.number,
	noLikes: PropTypes.bool,
	noMeta: PropTypes.bool,
	listingId: PropTypes.number,
	customerId: PropTypes.number,
	triggerLogin: PropTypes.func,
	onWishlistSuccess: PropTypes.func,
	className: PropTypes.string,
	storeName: PropTypes.string.isRequired,
	hasMoreProducts: PropTypes.bool,
	isAdmin: PropTypes.bool,
	flairTags: PropTypes.array,
	marketingBadges: PropTypes.array,
	numSales: PropTypes.number,
};

Title.propTypes = titleProps;

Title.defaultProps = {
	triggerLogin: () => null,
	onWishlistSuccess: () => null,
	isAdmin: false,
	flairTags: [],
	marketingBadges: [],
	numSales: null,
};

/* Wrap the Title to get access to LoginModalHoc */
const LoginCapableTitle = (props) =>
	<LoginModalHoc contextUsage="title-login">
		{({ triggerLoginModal }) =>
			<Title {...props} triggerLogin={triggerLoginModal} />
		}
	</LoginModalHoc>;


export default LoginCapableTitle;
